import { useNavigate } from 'react-router-dom';

export default function LifestyleBanner() {
  const navigate = useNavigate();

  return (
    <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/5638c131be3a92a41cef5c3e131ced94.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-2xl">
          <p className="text-cyan-400 font-bold text-sm uppercase tracking-widest mb-4">
            The AQUATEK Difference
          </p>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
            ENGINEERED FOR
            <br />
            PERFORMANCE
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed font-light">
            From the first light of dawn to the last cast at dusk, our gear is designed to perform when it matters most. Built by anglers, for anglers.
          </p>
          <button 
            onClick={() => navigate('/products')}
            className="bg-white hover:bg-cyan-600 text-gray-900 hover:text-white px-10 py-5 rounded-md text-lg font-bold transition-all cursor-pointer whitespace-nowrap uppercase tracking-wider shadow-xl transform hover:scale-105"
          >
            Discover More
          </button>
        </div>
      </div>
    </section>
  );
}
